module.exports = __webpack_public_path__ + "img/2.7b22f941.jpg";